<template>
    <translates
        :item="this.group"
        :item_id="parseInt(group.id)"
        item_type="group">
    </translates>
</template>

<script>
import translates from "../../../../translates/translates";

export default {
    name: "group_translate",
    components: {
        translates
    },
    props : {
        group : {
            type : Object
        }
    },
}
</script>

<style scoped>

</style>
